import { PropsWithChildren } from 'react';

import { CircularProgress, Fade, Stack, Typography } from '@mui/material';

export type LoadingProps = {
  isLoading?: boolean;
  text?: string;
};

export const Loading = ({ isLoading = true, text, children }: PropsWithChildren<LoadingProps>) =>
  isLoading || !(isLoading || children) ? (
    <Fade in unmountOnExit>
      <Stack justifyContent="center" alignItems="center" height={1} gap={2} data-testid="loading-container">
        <CircularProgress />
        {text && <Typography variant="natter-display-sm">{text}</Typography>}
      </Stack>
    </Fade>
  ) : (
    <>{children}</>
  );
